import { Data2, newId } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { TaxCategory } from '../../operations'
import { useSystemStateHooks } from '../../system'
import { Supplier } from '../state/types'

export const useSupplierBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildSupplier = (data: Data2) => {
        const {
            id = newId(),
            code,
            name,
            taxId,
            taxCategory,
            productSupplier,
            phone,
            email,
            address,
            paymentDays,
            grossIncomeCode,
            archived
        } = data

        const supplier: Supplier = {
            companyId: companyId!,
            id: id! as string,
            code: code! as number,
            name: name! as string,
            taxId: taxId! as number,
            taxCategory: taxCategory! as TaxCategory,
            productSupplier: productSupplier! as boolean,
            phone: phone as O<number>,
            email: email as O<string>,
            address: address as O<string>,
            paymentDays: paymentDays as O<number>,
            grossIncomeCode: grossIncomeCode as O<number>,
            archived: !!archived
        }

        return supplier
    }

    return {
        buildSupplier
    }
}
